import { recoilPersist } from 'recoil-persist';

export const { persistAtom } = recoilPersist({ storage: sessionStorage });
